import {combineEpics} from 'redux-observable';
import {loadDailyProvinceEpic} from './DailyProvinceEpics';
import {casesEpic} from './CasesEpics';

const epics = combineEpics(loadDailyProvinceEpic, casesEpic);

export default epics;
